<template>
  <div class="m-market-comb">
    <div class="m-market-row">
      <div class="m-title" />
      <template v-for="title in outcomeData.cols">
        <div
          :key="title"
          class="m-title"
        >
          {{ title }}
        </div>
      </template>
    </div>
    <template v-for="(row, key) in outcomeData.rows">
      <div
        :key="key"
        class="m-market-row"
      >
        <div class="m-outcome m-outcome-desc">
          <span class="m-outcome-desc-name">{{ key }}</span>
        </div>
        <template v-for="outcome in row">
          <Outcome
            :key="outcome.id"
            :outcome="outcome"
            :market="market"
            :event="event"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 六、组合类的Market
 * 规则描述：由两种单一的Market组成而成的Market，由&符合连接，例如：A&B
 */
import Outcome from 'wap/match/Event/pagelet/Outcome'

export default {
  name: 'Market6Comb',
  components: {
    Outcome
  },
  props: {
    market: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      outcomeData: {}
    }
  },
  watch: {
    'market.outcomes.order'(val) {
      if (val) {
        this.outcomeData = this.getOutcomeData()
      }
    }
  },
  created() {
    this.outcomeData = this.getOutcomeData()
  },
  methods: {
    getOutcomeData() {
      const { map, order } = this.market.outcomes
      const rows = {}
      const cols = []
      order.forEach((id) => {
        const outcome = map[id]
        const [rowDesc, colDesc] = outcome.description.split('&')
        if (colDesc) {
          const rowKey = rowDesc.trim()
          const colKey = colDesc.trim()
          if (rows[rowKey]) {
            rows[rowKey].push(outcome)
          } else {
            rows[rowKey] = [outcome]
          }
          if (!cols.includes(colKey)) {
            cols.push(colKey)
          }
        } else {
          rows[rowDesc] = [outcome]
        }
      })
      return { cols, rows }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-market-comb {
  .m-market-row {
    .m-title:first-child,
    .m-outcome.m-outcome-desc {
      width: 90/@rem;
      flex: none;
    }
  }
}
</style>
